export default axiosInstance => {
  async function auth({ platform, lineToken = undefined }) {
    return (
      await axiosInstance({
        method: "post",
        url: "/liff/auth",
        data: { platform, lineToken }
      })
    ).data;
  }

  return {
    auth
  };
};
